/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-plusplus */
/* eslint-disable default-param-last */
import React, { useState, useEffect } from 'react';
import CheckboxList from 'components/CheckboxList';
import { TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING_WITHOUT_INACTIVE } from 'helper/constants';
import CommonOrderComponent from '../CommonOrderComponent';

const OfferOrder = () => {
  const [activeView, setActiveView] = useState('kanban');
  const [selectedTabs, setSelectedTabs] = useState({
    [TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING_WITHOUT_INACTIVE.LIVE]: true,
    [TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING_WITHOUT_INACTIVE.FORWARD]: false,
    [TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING_WITHOUT_INACTIVE.FOREIGN]: false,
  });

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setSelectedTabs((prevTabs) => ({
      ...prevTabs,
      [name]: checked,
    }));
  };

  // Define defaultValue based on selectedTabs
  const getDefaultValue = () => {
    // const baseFilter = {
    //   key: 'orderType',
    //   value: 'OFFER',
    //   type: 'STRING',
    //   op: 'EQ',
    // };

    const selectedKeys = Object.entries(selectedTabs)
      .filter(([_, isSelected]) => isSelected)
      .map(([tab]) => tab);

    if (selectedKeys.length === 0) {
      // If no checkboxes are selected, include all values
      return [
        // baseFilter,
        {
          key: 'offerDemandType',
          value: 'FORWARD,LIVE,FOREIGN',
          type: 'STRING',
          op: 'IN',
        },
      ];
    }

    const filters = {
      key: 'offerDemandType',
      value: selectedKeys.join(','),
      type: 'STRING',
      op: 'IN',
    };

    return [filters];
  };

  const [defaultValue, setDefaultValue] = useState(getDefaultValue());

  useEffect(() => {
    setDefaultValue(getDefaultValue());
  }, [selectedTabs]);

  // Generate a unique key to force re-render of CommonOrderComponent
  const componentKey = JSON.stringify(defaultValue);

  const headerControls = (
    <>
      <div className="order-view-tabs">
        <button
          type="button"
          className={`order-view-tab ${activeView === 'kanban' ? 'active' : ''}`}
          onClick={() => setActiveView('kanban')}
        >
          Kanban
        </button>
        <button
          type="button"
          className={`order-view-tab ${activeView === 'listing' ? 'active' : ''}`}
          onClick={() => setActiveView('listing')}
        >
          Listing
        </button>
      </div>
      <CheckboxList
        LIST={TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING_WITHOUT_INACTIVE}
        handleCheckboxChange={handleCheckboxChange}
        selectedTabs={selectedTabs}
        className=""
      />
    </>
  );

  return (
    <CommonOrderComponent
      key={componentKey}
      defaultValue={defaultValue}
      type="offer"
      activeView={activeView}
      headerControls={headerControls}
    />
  );
};

export default OfferOrder;
